/**
 * Defines the supported timestamp units.
 */
export var TimestampUnit;
(function (TimestampUnit) {
    TimestampUnit[TimestampUnit["Milliseconds"] = 0] = "Milliseconds";
    TimestampUnit[TimestampUnit["Seconds"] = 1] = "Seconds";
    TimestampUnit[TimestampUnit["Minutes"] = 2] = "Minutes";
    TimestampUnit[TimestampUnit["Hours"] = 3] = "Hours";
})(TimestampUnit || (TimestampUnit = {}));
//# sourceMappingURL=graphSupportingTypes.js.map